/**
 * @generated SignedSource<<0f936347dbc9cc1832033539647c429a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackagePurchaseFooterQuery$variables = {
  memberPackageId: string;
  orderId: string;
};
export type StorePackagePurchaseFooterQuery$data = {
  readonly memberPackage: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrderFooter_memberPackage">;
  } | null | undefined;
  readonly order: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrderFooter_order">;
  } | null | undefined;
};
export type StorePackagePurchaseFooterQuery = {
  response: StorePackagePurchaseFooterQuery$data;
  variables: StorePackagePurchaseFooterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberPackageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "memberPackageId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orderId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorePackagePurchaseFooterQuery",
    "selections": [
      {
        "alias": "memberPackage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoreProductOrderFooter_memberPackage"
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "order",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoreProductOrderFooter_order"
              }
            ],
            "type": "Order",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorePackagePurchaseFooterQuery",
    "selections": [
      {
        "alias": "memberPackage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareCardOnFile",
                "kind": "LinkedField",
                "name": "squareCard",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DisplayInApp",
                    "kind": "LinkedField",
                    "name": "displayInApp",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "termsAndConditionsUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "order",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "packageDueDate",
                "storageKey": null
              }
            ],
            "type": "Order",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c48b28fd2ad1a04304e28756676f560b",
    "id": null,
    "metadata": {},
    "name": "StorePackagePurchaseFooterQuery",
    "operationKind": "query",
    "text": "query StorePackagePurchaseFooterQuery(\n  $memberPackageId: ID!\n  $orderId: ID!\n) {\n  memberPackage: node(id: $memberPackageId) {\n    __typename\n    ... on MemberPackage {\n      id\n      ...StoreProductOrderFooter_memberPackage\n    }\n    id\n  }\n  order: node(id: $orderId) {\n    __typename\n    ... on Order {\n      ...StoreProductOrderFooter_order\n    }\n    id\n  }\n}\n\nfragment StoreProductOrderFooter_memberPackage on MemberPackage {\n  id\n  squareCard {\n    id\n  }\n  package {\n    __typename\n    displayInApp {\n      termsAndConditionsUrl\n    }\n    id\n  }\n}\n\nfragment StoreProductOrderFooter_order on Order {\n  id\n  total\n  ...useIsPackageOrderDue_order\n}\n\nfragment useIsPackageOrderDue_order on Order {\n  packageDueDate\n}\n"
  }
};
})();

(node as any).hash = "c01ed588b593b86e5477c856348af317";

export default node;
